import Api from '../http.service';
/**
 * @param {object} data
 * @param {Number} data.pageNumber
 * @param {Number} data.itemPerPage
 * @param {string} data.cityCode
 */

export const getAll = ({ pageNumber = 1, itemPerPage = 10, cityCode }) =>
  Api.GET({
    url: `hotel/?page=${pageNumber - 1}&size=${itemPerPage}${
      cityCode ? `&cityCode=${cityCode}` : ''
    }`,
  });

/**
 * @param {object} data
 * @param {string} data.cityCode
 */
export const getByCity = ({ cityCode }) =>
  Api.GET({
    url: `hotel/city/${cityCode}`,
  });

/**
 * @param {object} data
 * @param {string} data.hotelId
 */
export const getRooms = ({ hotelId }) =>
  Api?.GET({ url: `eghamat24/room-types/${hotelId}` });
